export default __webpack_public_path__ + "static/media/class_logo-icon.9bfe8e1b.svg";